<template>
	<div class="footer">
		<div class="online">
			<div class="footbox">
				<div class="online_div">
					<p><a href="http://csc.ourgame.com/" target="_blank"><span><img src="../assets/img/icon_service.jpg" alt="" /></span>在线提问</a></p>
				</div>
				<div class="online_div">
					<p><a href="http://newpay.ourgame.com/" target="_blank"><span><img src="../assets/img/icon_pay.jpg" alt="" /></span>在线充值</a></p>
				</div>
				<div class="online_div div3">
					<p><a href="http://bbs.lianzhong.com/" target="_blank"><span><img src="../assets/img/icon_lz.jpg" alt="" /></span>联众论坛</a></p>
				</div>
			</div>
		</div>
		<div class="footinfo">
			<div class="footbox">
				<!-- <script src="http://www.ourgame.com/include/copyright.js"></script> -->
				<ul>
					<li>
						<a href>群众简介</a>|
						<a href>合作伙伴</a>|
						<a href>服务条款</a>|
						<a href>联系我们</a>|
						<a href>Investor Relations</a>
					</li>
					<li>游戏中使用的游戏币、门票等群为游戏道具，不具有任何财产性功能，只限用户本人在游戏中使用。本公司对于用户所拥有的游戏币、门票不提供任何形式的官方回购、</li>
					<li>直接或变相兑换现金或实物等服务及相关功能。本公司严禁用户之间在游戏中及线下进行任何叫卖、转让游戏币等行为，如一经查出则永久封杀</li>
					<li>通用网址：联众世界</li>
					<li>网络文化经营许可证 京网文[2018]5376-415号 | 增值电信业务经营许可证 京B2-20181260号</li>
					<li>中国计算机信息网络国际联网单位编号：11010502017837|网站备案号：京ICP备09074391号-2 | 京ICP证080029号</li>
					<li>批准文号：科技与数字[2013]20号 | ISBN 978-7-89989-583-2 | 公安机关备案号：11010502017838</li>
					<li>北京联众网络股份有限公司版权所有2014 | 北京联通提供网络带宽</li>
					<li>公司名称：北京联众互联网络有限公司 | 公司邮箱：cs@staff.ourgame.com</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	export default {
		name: 'AucFooter',
		data() {
			return {

			}
		},
		components: {

		}
	}
</script>
<style>
	.footbox { width: 1008px; margin: 0 auto; }
	.online { background: #fafafa; height: 147px; }
	.online .online_div { width: 364px; height: 66px; line-height: 66px; float: left; padding-top: 40px; }
	.online .div3 { width: 279px; }
	.online .online_div p { width: 275px; height: 66px; line-height: 66px; background: #fff; border:2px #f5f5f5 solid; }
	.online .online_div p a { display: block; width: 175px; height: 66px; font-size: 16px; color: #48433a; text-decoration: none; position: relative; text-align: right; padding-right: 100px; }
	.online .online_div p a span { display: block; position: absolute; top: 12px;left: 50px; }
	.footinfo { background: #606266; margin: auto;}
	.footinfo ul { width: 100%; height: 100%;	padding: 15px 0 15px 0;	}
	.footinfo ul li { width: 100%; text-align: center; color: #fff; padding-top: 10px; }
	.footinfo ul li a { color: #fff; }
</style>